import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import "./_style.scss";
import useLanguageProvider from "components/LanguageProvider/hooks/useLanguageProvider";
import { IconChevronDown } from "../Icon";
export const generateDonationOptionsArray = (donationOptions) => {
    if (!donationOptions) {
        return [];
    }
    return donationOptions.map((val) => val);
};
export const initialValueInDonationOptions = (donationOptions, initialValue) => (donationOptions ? donationOptions.includes(initialValue) : false);
export const defaultDonationOptions = [25, 50, 100, 200];
const DonationSelector = ({ currencySymbol, currencyText, donationOptions: donationOptionsProp, handleDonationAmountChange, initialValue, name = "donationAmount", onChange, resetSelected = false, setFieldValue, setSelectedIndex, openCurrencyModal, value, showCurrencySelector = false, }) => {
    const [selectedIndex, setLocalSelectedIndex] = useState(null);
    const [otherIsActive, setOtherIsActive] = useState(false);
    const defaultValue = initialValue !== null && initialValue !== void 0 ? initialValue : undefined;
    const { translate: t } = useLanguageProvider();
    const donationOptions = useMemo(() => {
        if (donationOptionsProp) {
            return donationOptionsProp.length === 0 ? defaultDonationOptions : donationOptionsProp;
        }
        return defaultDonationOptions;
    }, [donationOptionsProp]);
    useEffect(() => {
        if (resetSelected) {
            setLocalSelectedIndex(null);
            setSelectedIndex(null);
        }
    }, [resetSelected, setSelectedIndex]);
    const setIndexes = (index) => {
        setLocalSelectedIndex(index);
        setSelectedIndex(index);
    };
    useEffect(() => {
        const optionsArray = generateDonationOptionsArray(donationOptions);
        if (initialValueInDonationOptions(optionsArray, initialValue)) {
            const index = optionsArray.findIndex((i) => i === initialValue);
            setLocalSelectedIndex(index);
            setSelectedIndex(index);
        }
        else {
            setOtherIsActive(!!initialValue);
        }
    }, [donationOptions, initialValue, setSelectedIndex]);
    const handleChange = (event) => {
        var _a;
        const target = (_a = event.currentTarget.getAttribute("data-index")) !== null && _a !== void 0 ? _a : "";
        setIndexes(Number.parseInt(target, 10));
        setOtherIsActive(false);
        if (document.getElementById("donation-selector-option-other")) {
            const otherDonationAmount = document.getElementById("donation-selector-option-other");
            if (otherDonationAmount) {
                otherDonationAmount.value = "";
            }
        }
        const donationAmount = Number.parseFloat(event.currentTarget.value);
        if (!setFieldValue) {
            // Trigger update of value to the redux-form field
            onChange(donationAmount, handleDonationAmountChange(donationAmount));
        }
        else {
            setFieldValue("donationAmount", donationAmount);
            handleDonationAmountChange(donationAmount);
        }
    };
    const handleOtherChange = (event) => {
        const inputEl = event.currentTarget;
        setIndexes(-1);
        setOtherIsActive(true);
        if (inputEl.value === "") {
            if (!setFieldValue) {
                // Trigger update of value to the redux-form field
                onChange(0, handleDonationAmountChange(0));
            }
            else {
                setFieldValue("donationAmount", 0);
                handleDonationAmountChange(0);
            }
            return;
        }
        let otherValue = Number.parseFloat(inputEl.value);
        if (!Number.isNaN(otherValue) && otherValue < 1) {
            otherValue = 1;
            inputEl.value = "1";
        }
        const otherValueParsed = Number.isNaN(otherValue)
            ? 0.0
            : Math.round(otherValue * 1e2) / 1e2;
        if (!setFieldValue) {
            // Trigger update of value to the redux-form field
            onChange(otherValueParsed, handleDonationAmountChange(otherValueParsed));
        }
        else {
            setFieldValue("donationAmount", otherValueParsed);
            handleDonationAmountChange(otherValueParsed);
        }
    };
    return (_jsxs("div", { className: "donation-selector", children: [_jsx("input", { type: "hidden", name: name, value: value }), showCurrencySelector && (_jsxs("div", { className: "donation-selector__currency", "data-testid": "donation-selector-currency", children: [_jsx("span", { className: "donation-selector__currency-label", children: "You're donating in" }), _jsxs("button", { type: "button", "data-testid": "donation-selector__currency-button", className: "donation-selector__currency-button", id: "donation-selector-currency-button", onClick: openCurrencyModal, children: [_jsx("div", { children: currencyText }), _jsx("div", { className: "currency-button-icon", children: _jsx(IconChevronDown, { height: "0.9rem" }) })] })] })), _jsx("div", { className: "donation-selector__options", "data-testid": "donation-selector__options", children: donationOptions.map((donationValue, index) => {
                    let optionBaseClass = "donation-selector__option";
                    if (!showCurrencySelector) {
                        optionBaseClass += " --rounding";
                    }
                    const optionClass = selectedIndex === index
                        ? `${optionBaseClass} --active`
                        : optionBaseClass;
                    return (_jsxs("label", { className: optionClass, htmlFor: `donation-selector-option-${donationValue}`, children: [currencySymbol, donationValue, _jsx("input", { className: "donation-selector__option-input", "data-index": index, id: `donation-selector-option-${donationValue}`, "data-testid": `donation-selector-option-${donationValue}`, name: name, onChange: handleChange, type: "radio", value: donationValue, checked: selectedIndex === index })] }, `donationAmount ${donationValue}`));
                }) }), _jsx("div", { className: "donation-selector__other", children: _jsxs("label", { className: `donation-selector__option-other${otherIsActive ? " --active" : ""}`, htmlFor: "donation-selector-option-other", children: [_jsx("span", { className: "donation-selector__input-currency", children: currencySymbol }), _jsx("input", { "data-testid": "donation-selector__input-other", className: "donation-selector__input-other", id: "donation-selector-option-other", min: "1", onChange: handleOtherChange, onFocus: handleOtherChange, placeholder: t("Enter amount"), step: "0.01", type: "number", defaultValue: defaultValue })] }) })] }));
};
export default DonationSelector;
